import { render } from "./App.vue?vue&type=template&id=72bacd70&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=72bacd70&scoped=true&lang=css"

import exportComponent from "D:\\work\\资料\\08元界\\01项目\\git\\crm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bacd70"]])

export default __exports__